import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _CategoriesContainer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { jsx } from '@instructure/emotion';
import { Text } from '@instructure/ui-text';
import { Menu } from '@instructure/ui-menu';
import { ScreenReaderContent, PresentationContent } from '@instructure/ui-a11y-content';
import Pill from '../Pill';
import Category from './components/Category';
import DropTargetContainer from '../DropTargetContainer';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var ENTER_KEY = 'Enter';
var SPACE_KEY = ' ';
var CategoriesContainer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_CategoriesContainer = /*#__PURE__*/function (_Component) {
  function CategoriesContainer() {
    var _this2;
    _classCallCheck(this, CategoriesContainer);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, CategoriesContainer, [].concat(_args));
    _defineProperty(_this2, "handleCategoryKeyPress", function (event) {
      if (event.key === ENTER_KEY || event.key === SPACE_KEY) {
        event.preventDefault();
        // popoverMenu triggers on keyup, so waiting to
        // open it once the keyup is done
        // synthetic events error with async calls on targets
        // so adding this null check to avoid
        var target = event.target;
        setTimeout(function () {
          target && target.click();
        });
      }
    });
    _defineProperty(_this2, "renderTargetCategory", function (item) {
      return jsx(DropTargetContainer, {
        key: item.id,
        className: "categoryContainer",
        css: _this2.props.styles.categoryContainerWrapper,
        onDrop: function onDrop() {
          var _this2$props;
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return (_this2$props = _this2.props).onDrop.apply(_this2$props, [item.id].concat(args));
        }
      }, jsx(Category // Will need to remove this once inst-ui id updated and revert to old way
      , {
        itemBody: item.itemBody,
        itemId: item.id,
        userResponse: _this2.userResponseCategory(item.id),
        categoryTrigger: _this2.renderCategoryBody(item.id, item.itemBody),
        categoryContent: _this2.renderCategoryPopoverContent(item.id),
        styles: _this2.props.styles
      }), jsx(PresentationContent, null, jsx("div", {
        className: "keyboardHelp",
        css: _this2.props.styles.keyboardHelp
      }, jsx(Text, {
        color: "primary"
      }, t('Press Enter or Space to change selection')))));
    });
    _defineProperty(_this2, "renderStaticCategory", function (item) {
      return jsx("div", {
        key: item.id,
        css: _this2.props.styles.categoryContainerWrapper
      }, jsx("div", {
        css: _this2.props.styles.categoryContainer
      }, jsx("span", null, jsx(ScreenReaderContent, null, t('Category')), jsx(Text, {
        color: "primary"
      }, item.itemBody)), _this2.renderCategoryBody(item.id, item.itemBody)));
    });
    return _this2;
  }
  _inherits(CategoriesContainer, _Component);
  return _createClass(CategoriesContainer, [{
    key: "userResponseCategory",
    value:
    // ===========
    //   HELPERS
    // ===========

    function userResponseCategory(categoryId) {
      var response = find(this.props.userResponseValue, {
        id: categoryId
      });
      if (!response) {
        return [];
      }
      return response.value || [];
    }
  }, {
    key: "isDistractorSelected",
    value: function isDistractorSelected(categoryId, idDistractor) {
      return this.userResponseCategory(categoryId).includes(idDistractor);
    }
  }, {
    key: "renderCategoryBody",
    value:
    // ===========
    //   RENDER
    // ===========

    function renderCategoryBody(categoryId, categoryName) {
      var _this3 = this;
      if (this.props.categoryBody) {
        return this.props.categoryBody(categoryId);
      }
      var response = this.userResponseCategory(categoryId);
      var hasNoResponse = response.length === 0;
      var containerProps = this.props.isDraggable ? {
        tabIndex: '0',
        role: 'button'
      } : {};
      return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        jsx("div", Object.assign({}, containerProps, {
          css: this.props.styles.popoverTrigger,
          onKeyPress: this.handleCategoryKeyPress,
          ref: this.props.handleCategoryRef(categoryId)
        }), jsx(ScreenReaderContent, null, t('Selected Answers for category {category_name}: Click to change selection.', {
          category_name: categoryName
        })), jsx("div", {
          className: "fs-mask",
          css: hasNoResponse ? this.props.styles.categoryContainer.categoryContentEmpty : this.props.styles.categoryContainer.categoryContentFilled
        }, hasNoResponse ? jsx(Text, {
          color: "secondary"
        }, t('No Answers Chosen')) : response.map(function (distractorId) {
          var id = "".concat(_this3.props.distractors[distractorId].id, "_").concat(_this3.props.takeId);
          return jsx(Pill, {
            key: distractorId,
            id: id,
            itemBody: _this3.props.distractors[distractorId].itemBody,
            isDraggable: _this3.props.isDraggable,
            onDropOut: _this3.props.onDropOut
          });
        })))
      );
    }
  }, {
    key: "renderCategoryPopoverContent",
    value: function renderCategoryPopoverContent(categoryId) {
      var _this4 = this;
      return this.props.filterDistractors(categoryId).map(function (distractor) {
        var checked = _this4.isDistractorSelected(categoryId, distractor.id);
        return jsx(Menu.Item, {
          key: distractor.id,
          type: "checkbox",
          selected: checked,
          onSelect: function onSelect(event) {
            return _this4.props.onMenuItemSelected(distractor.id, categoryId, checked, event);
          }
        }, distractor.itemBody);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.categoriesContainer
      }, this.props.sortedCategories.map(this.props.isDraggable ? this.renderTargetCategory : this.renderStaticCategory)));
    }
  }]);
}(Component), _defineProperty(_CategoriesContainer, "displayName", 'CategoriesContainer'), _defineProperty(_CategoriesContainer, "componentId", "Quizzes".concat(_CategoriesContainer.displayName)), _defineProperty(_CategoriesContainer, "propTypes", {
  sortedCategories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    itemBody: PropTypes.string
  })).isRequired,
  categoryBody: PropTypes.func,
  distractors: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string,
    itemBody: PropTypes.string
  })).isRequired,
  filterDistractors: PropTypes.func,
  handleCategoryRef: PropTypes.func,
  isDraggable: PropTypes.bool,
  onDrop: PropTypes.func,
  onDropOut: PropTypes.func,
  onMenuItemSelected: PropTypes.func,
  userResponseValue: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string
  })),
  takeId: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_CategoriesContainer, "defaultProps", {
  categoryBody: null,
  isDraggable: false,
  filterDistractors: function filterDistractors() {},
  handleCategoryRef: function handleCategoryRef() {},
  onDrop: function onDrop() {},
  onDropOut: function onDropOut() {},
  onMenuItemSelected: function onMenuItemSelected() {},
  userResponseValue: [],
  takeId: ''
}), _CategoriesContainer)) || _class);
export { CategoriesContainer as default };